import { render, staticRenderFns } from "./IPRestrictions.vue?vue&type=template&id=226f11be&scoped=true&"
import script from "./IPRestrictions.vue?vue&type=script&lang=js&"
export * from "./IPRestrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f11be",
  null
  
)

export default component.exports